import styled from 'styled-components';

const FeaturedContentInnerContainer = styled.div`
  width: 100%;
  height: 0;
  flex: 1;
  margin: 0 auto;
`;

const RichTextContainer = styled.div`
  margin-top: 20px;

  p {
    font-size: 16px;
  }
`;

export { FeaturedContentInnerContainer, RichTextContainer };
